import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function WhiteBorder({ children }) {
    return (_jsxs("div", { style: {
            position: 'relative',
            zIndex: 10,
            cursor: 'pointer',
            alignSelf: 'flex-start',
        }, children: [_jsx("div", { style: {
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '38px',
                    filter: 'blur(24px)', // blur-xl
                    transition: 'all 300ms ease',
                    background: 'linear-gradient(135deg, rgba(74, 63, 112, 0.4), rgba(43, 38, 61, 0.3))',
                } }), _jsxs("div", { style: {
                    position: 'relative',
                    display: 'block',
                    maxWidth: '75vw',
                    overflow: 'hidden',
                    borderRadius: '9999px',
                    padding: '4px', // px-1 py-1
                    fontSize: '1rem',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(24px)',
                    WebkitBackdropFilter: 'blur(24px)',
                    transition: 'all 300ms ease',
                    transform: 'perspective(1000px) translateZ(10px)',
                    backgroundImage: 'linear-gradient(180deg, rgba(45, 40, 60, 0.4) 0%, rgba(20, 18, 25, 0.6) 100%)',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.15)',
                }, children: [_jsx("div", { style: {
                            pointerEvents: 'none',
                            position: 'absolute',
                            inset: 0,
                            borderRadius: '9999px',
                            boxShadow: 'inset 0 10px 20px rgba(255, 255, 255, 0.05)',
                        } }), _jsx("div", { style: {
                            position: 'relative',
                            zIndex: 10,
                            fontWeight: 500,
                            color: '#ffffff',
                        }, children: children })] })] }));
}
export default WhiteBorder;
